var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _c(
        "div",
        {
          ref: "popoverTarget",
          staticClass: "tooltip-target no-outline",
          attrs: { tabindex: "-1" },
        },
        [
          _c("board-changelog-item", {
            class: {
              "column-divider-bottom": !_vm.isLast,
              "clickable changelog-details-tooltip": !!_vm.changelogComponent(
                _vm.changelog.type
              ),
            },
            attrs: {
              "user-details": _vm.userDetails,
              changelog: _vm.changelog,
              "board-id": _vm.boardId,
              origin: _vm.origin,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "BoardChangelogPopover",
          attrs: {
            id: "BoardChangelogPopover",
            target: _vm.getPopoverTarget,
            triggers: _vm.tooltipTrigger,
            placement: "right",
            "custom-class": "w-50",
            boundary: "viewport",
          },
        },
        [
          _c(
            "div",
            { staticClass: "changelog-popover" },
            [
              _c(_vm.changelogComponent(_vm.changelog.type), {
                tag: "component",
                attrs: {
                  value: _vm.changelog.value,
                  operation: _vm.changelog.operation,
                  field: _vm.changelog.field,
                  type: _vm.changelog.type,
                  "insertion-timestamp": _vm.changelog.insertionTimestamp,
                  "user-details": _vm.changelog.userDetails,
                  "small-text": false,
                  "show-value-on-new-line": "",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }